/**
 * La palette « / » au clavier : ↑ ↓ déplacent la commande éclairée, en boucle ; Entrée prend celle-là. Une autre
 * touche, ou une palette vide, reste au champ (`null`). Une commande éclairée que le texte a retirée de la palette
 * revient à la première.
 */
export function paletteKey(key: string, index: number, count: number): { move: number } | { pick: number } | null {
    if (count === 0) return null
    const at = index < count ? index : 0
    if (key === "ArrowDown") return { move: (at + 1) % count }
    if (key === "ArrowUp") return { move: (at - 1 + count) % count }
    if (key === "Enter") return { pick: at }
    return null
}
